let mobx = require('mobx');
// create State object
let data = {
    order: {},
    recordList: [],
    inputTxt: '',
    agoraEngine: null,
    is_show_waiting_peer_receive_phone_dialog: false, // 是否显示等待对方接听电话的弹窗
    dialog_peer_is_calling_you: null, // 对方正在呼叫你的弹窗
    dialog_connecting: null, // 正在连接的弹窗
}
let cancelOrderState = mobx.observable(data);

// export default loginState;
module.exports = cancelOrderState;
